import { NewDealTriage } from '@features/templateModes/documents/NewDealTriage';
import { GrowthEquityMemo } from '@features/templateModes/documents/GrowthEquityMemo';
import React from 'react';
import { Body5, Container } from '@ui';
import { Working } from '@ui/Working';
import { useDocumentTemplateAnswers } from '@hooks/features/useDocumentTemplateAnswers';
import { InvestmentMemo } from '@features/templateModes/documents/InvestmentMemo';
import { NewDealEvaluation } from '@features/templateModes/documents/NewDealEvaluation';
import { QuickLook } from '@features/templateModes/documents/QuickLook';
import { GenericMemo } from '@features/templateModes/documents/GenericMemo';
import { PortfolioSnapshot } from '@features/templateModes/documents/PortfolioSnapshot';
import { DOCUMENT_TEMPLATE_MODE_IDS } from '@constants';

function Template({ modeId, answers, selectedDocs, isStreamComplete }) {
  if (!modeId) return null;

  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.quarterly_data_template)
    return <GenericMemo answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.financial_statement_template)
    return <GenericMemo answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.quick_look)
    return <QuickLook answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.new_deal_evaluation)
    return <NewDealEvaluation answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.new_deal_triage)
    return <NewDealTriage answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.growth_equity_memo_template)
    return <GrowthEquityMemo answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.investment_memo_template)
    return <InvestmentMemo answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.portfolio_snapshot_template)
    return <PortfolioSnapshot answers={answers} selectedDocs={selectedDocs} isStreamComplete={isStreamComplete} />;
  return <div>Missing Template</div>;
}

export function DocumentTemplateAnswers({ modeId, resultId, selectedDocs, queryListMetadata, onStreamComplete }) {
  const {
    answersLookup,
    error: streamingError,
    streamEnd: streamComplete,
  } = useDocumentTemplateAnswers(resultId, queryListMetadata);

  React.useEffect(() => {
    if (streamComplete) {
      onStreamComplete();
    }
  }, [streamComplete]);

  if (!answersLookup || Object.keys(answersLookup).length === 0) {
    return (
      <Container top={100} bottom={200}>
        <Working />
      </Container>
    );
  }

  return (
    <Container>
      {streamingError && (
        <Container bottom={24}>
          <Body5>An unexpected error occurred. Please try again.</Body5>
        </Container>
      )}
      <Template modeId={modeId} answers={answersLookup} selectedDocs={selectedDocs} isStreamComplete={streamComplete} />
    </Container>
  );
}
